import {Helmet} from 'react-helmet';
import Contact from "../../Page/contact";



const faqsContent ={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Who is the best freelance website designer in Amritsar?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Pankaj Singh is a trusted freelance website designer in Amritsar offering custom web design, development, and SEO services tailored for local businesses and professionals."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide responsive website design services in Amritsar?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, all websites are designed to be fully responsive, ensuring they function perfectly on mobile, tablet, and desktop devices."
      }
    },
    {
      "@type": "Question",
      "name": "What types of websites do you create in Amritsar?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "I design all kinds of websites including business sites, personal portfolios, eCommerce stores, landing pages, blogs, and more."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to build a website?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Typically, a basic website takes 5-10 days depending on content readiness, features, and feedback cycles. Complex sites may take longer."
      }
    },
    {
      "@type": "Question",
      "name": "Can you help with SEO for my Amritsar-based website?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I offer basic on-page SEO with all websites, and advanced SEO packages to help your site rank higher on Google search results."
      }
    },
    {
      "@type": "Question",
      "name": "Will I be able to update the content on my website myself?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. I can build your site using a user-friendly CMS like WordPress or Webflow, allowing you to manage and update your content easily."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer website redesign services in Amritsar?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I can refresh and redesign outdated websites to improve their design, functionality, and performance."
      }
    },
    {
      "@type": "Question",
      "name": "Can you integrate WhatsApp or chat support on my website?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, WhatsApp integration and chat widgets can be added to enhance customer communication and support."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide domain and hosting support?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I can assist you in purchasing and configuring your domain and hosting, or recommend reliable providers."
      }
    },
    {
      "@type": "Question",
      "name": "What is the cost of a freelance website designer in Amritsar?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Website design pricing varies based on the project scope and features. Contact me for a transparent quote tailored to your needs."
      }
    }
  ]
}

function App1() {
  return (
   <>
   <Helmet>
    <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
<title>Pankaj | Website Designer In Amritsar</title>
<meta name="description" content="Top website designer in Amritsar. Get a modern website design with me in low cost. Elevate your online presence today!"/>
<meta name="keywords" content="website designer in amritsar, web design company amritsar, web development company in amritsar, website development company in amritsar, web development in amritsar, website developer amritsar, website developer in amritsar, website design company in amritsar, web design amritsar, website development in amritsar, website developer near me"/>
<meta property="og:title" content="Pankaj | Website Designer In Amritsar" />
<meta property="og:description" content="Top Website Designer In Amritsar. Get a modern website design with me in low cost. Elevate your online presence today!" />
<meta property="og:site_name" content="Pankaj | Website Designer In Amritsar" />
<meta property="og:url" content="https://www.pankj.com/website-designer-in-amritsar"/>
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg"/>
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Pankaj | Website Designer In Amritsar" />
<meta name="twitter:description" content="Top website designer in Amritsar. Get a modern website design with me in low cost. Elevate your online presence today!" />
<link rel="canonical" href="https://www.pankj.com/website-designer-in-amritsar" />
        </Helmet>
 <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
                <source src="assets/img/bg.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
            <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />
  <h1 className="multiple_effects fzsml" id="text3d">Website Designer in Amritsar</h1>
          <div className="content_sec" data-aos="fade-up" data-aos-delay="400">Take a look at some of my works, and if you like them, feel free to contact me.</div>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/pks2.webp" alt="Website Designer" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   

    <main id="main">
  <section id="pageContent" className="pageContent">

      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>Website Designer in Amritsar</h2>
        </header>

        <div className="row">
          <div className="col-lg-12">
<p>Welcome to Pankaj's Web Design Services! Based in the historic city of Amritsar, I specialize in creating professional and engaging websites that help businesses and individuals stand out online. With a focus on user experience and modern design, I am dedicated to crafting websites that not only look great but also function seamlessly to meet your goals.</p>

<h3>Services Offered</h3>
<ol>
  <li><strong>Custom Website Design</strong> – Every brand is unique, and your website should reflect that. I create custom designs tailored to your specific needs, whether it’s a corporate site, creative portfolio, or e-commerce platform.</li>
  <li><strong>E-Commerce Solutions</strong> – Launch and manage your online store with secure payment gateways, intuitive navigation, and engaging product displays to boost conversions.</li>
  <li><strong>Responsive Web Development</strong> – All websites are fully responsive, ensuring smooth performance on desktops, tablets, and smartphones.</li>
  <li><strong>SEO-Friendly Websites</strong> – I follow SEO best practices to improve rankings, optimize content, and attract more visitors organically.</li>
  <li><strong>Website Redesign</strong> – If your site needs a fresh look or improved functionality, I offer redesign services aligned with your business goals.</li>
  <li><strong>CMS Integration</strong> – Using platforms like WordPress, you can manage and update your website easily without technical expertise.</li>
  <li><strong>Maintenance & Support</strong> – After launch, I provide ongoing support, updates, and troubleshooting to keep your site running smoothly.</li>
  <li><strong>Digital Marketing</strong> – Basic SEO and online marketing solutions to help you reach and engage your audience more effectively.</li>
</ol>

<h3>Why Choose Me?</h3>
<ul>
  <li><strong>Experience:</strong> Over a decade of expertise in designing high-quality, user-focused websites.</li>
  <li><strong>Client-Centric Approach:</strong> I focus on your goals and vision to deliver results that exceed expectations.</li>
  <li><strong>Affordable Pricing:</strong> Quality services at competitive rates to suit your budget.</li>
  <li><strong>Timely Delivery:</strong> Projects completed within deadlines without compromising quality.</li>
</ul>

<h3>Let’s Build Your Online Presence</h3>
<p>If you’re looking for a reliable website designer in Amritsar, I’d love to help bring your vision to life. Get in touch today to discuss your project and take the first step toward a stronger online presence.</p>

Let’s work together to create a stunning website that elevates your brand and connects with your audience. Contact me today for a consultation and a free quote!

<h2>Frequently Asked Questions</h2>

<h4>1. What services do you offer as a website designer?</h4>
<p>I provide a comprehensive range of services, including custom website design, e-commerce solutions, responsive web development, SEO-friendly websites, website redesign, CMS implementation, ongoing maintenance and support, and basic digital marketing services.</p>

<h4>2. How long does it take to design and develop a website?</h4>
<p>The timeline for designing and developing a website can vary based on its complexity and your specific requirements. Generally, a basic website takes about 2-4 weeks, while more complex projects may take longer. I will provide you with a detailed timeline during our initial consultation.</p>

<h4>3. Will my website be mobile-friendly?</h4>
<p>Yes! All websites I create are fully responsive, ensuring they look great and function well on all devices, including desktops, tablets, and smartphones. This guarantees an excellent user experience for all visitors.</p>

<h4>4. Can you help with SEO for my website?</h4>
<p>Absolutely! I incorporate SEO best practices during the website design process to improve your site's visibility on search engines. This includes optimizing your site's structure, content, and images to attract organic traffic.</p>

<h4>5. Do you provide ongoing support after the website is launched?</h4>
<p>Yes, I offer ongoing maintenance and support services to ensure your website runs smoothly after launch. This includes regular updates, troubleshooting, and assistance with any issues that may arise.</p>

<h4>6. How do I update my website after it’s launched?</h4>
<p>If you choose to use a Content Management System (CMS) like WordPress, you will have the ability to update your website content independently. I will provide you with training on how to manage your site, and I'm always available to assist you with any other changes or updates you may need.</p>

<h4>7. What is the cost of your website design services?</h4>
<p>The cost of website design services varies based on factors such as the complexity of the project, features required, and your specific needs. I provide a free quote after discussing your project in detail to ensure a solution that fits your budget.</p>

<h4>8. Can you redesign my existing website?</h4>
<p>Yes, I offer website redesign services to refresh and improve your current site. This may involve updating the layout, enhancing functionality, and optimizing for better performance and user experience.</p>

<h4>9. How do we get started on a project?</h4>
<p>To get started, simply contact me through my website or reach out via email or phone. We’ll schedule a consultation to discuss your project goals, timeline, and budget, allowing us to create a tailored plan for your website.</p>

<h4>10. Why should I choose you as my website designer?</h4>
<p>With over a decade of experience, a client-centric approach, and a commitment to delivering high-quality results on time, I am dedicated to helping you create a website that meets your needs and exceeds your expectations. Your satisfaction is my top priority!</p>


          </div>
        </div>
      </div>

    </section>
 <Contact />
    </main>
    </>
  );
}
export default App1;
